export interface BaseEntity {
  id?: any;
}
